import React from 'react';
import { motion } from 'framer-motion';
import { Building, Home, Handshake, Globe } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Building,
      title: 'Luxury Consulting',
      description:
        'Strategic advisory for high-value property acquisitions, leveraging market intelligence and exclusive networks to secure the finest investments.',
    },
    {
      icon: Home,
      title: 'Second Home Curation',
      description:
        'Discover bespoke vacation homes and weekend retreats in premium destinations—from coastal villas in Alibaug to hill-station sanctuaries in Lonavala.',
    },
    {
      icon: Handshake,
      title: 'Developer Partnerships',
      description:
        'Direct access to pre-launch opportunities and exclusive inventory from India\'s most prestigious developers, ensuring priority pricing and selection.',
    },
    {
      icon: Globe,
      title: 'International Properties',
      description:
        'Expand your portfolio globally with curated luxury properties in Dubai and other key international markets, backed by comprehensive legal and financial guidance.',
    },
  ];

  return (
    <section id="services" className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-accent" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-secondary text-sm font-medium tracking-widest uppercase">Our Services</span>
          <h2 className="font-playfair text-4xl lg:text-5xl font-bold text-primary mt-4 mb-6 tracking-tight">
            Comprehensive Luxury Solutions
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            From strategic advisory to seamless transactions, we provide end-to-end luxury real estate services
            tailored to the unique needs of discerning clientele.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`service-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="group bg-white p-8 border border-muted hover:border-secondary transition-all duration-500 hover:shadow-[0_20px_40px_-4px_rgba(15,40,30,0.2)]"
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/5 border border-secondary/30 mb-6 group-hover:border-secondary transition-colors duration-500">
                  <Icon className="text-secondary" size={28} />
                </div>

                {/* Content */}
                <h3 className="font-playfair text-2xl font-semibold text-primary mb-4">{service.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{service.description}</p>

                {/* Hover Line */}
                <div className="mt-6 h-px bg-secondary/0 group-hover:bg-secondary transition-all duration-500 w-0 group-hover:w-20" />
              </motion.div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-center mt-16"
        >
          <a
            href="/contact"
            data-testid="services-contact-cta"
            className="inline-block bg-primary text-primary-foreground hover:bg-[#1A3F30] px-8 py-6 font-manrope tracking-wide uppercase text-xs transition-all duration-300"
          >
            Discuss Your Requirements
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
